import { render } from "./safe.vue?vue&type=template&id=5d4b7d6a&scoped=true"
import script from "./safe.vue?vue&type=script&lang=js"
export * from "./safe.vue?vue&type=script&lang=js"

import "./safe.vue?vue&type=style&index=0&id=5d4b7d6a&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4b7d6a"]])

export default __exports__